import React from "react"
import styled from "styled-components"

import {
    RadioCheckedIcon,
    RadioUncheckedIcon,
    EyeIcon,
    EyeBlockedIcon,
    SpinnerIcon,
} from "client/components"
import {
    ACTIVE,
    INACTIVE,
    PUBLISHED,
    UNPUBLISHED,
    PENDING,
} from "const"

export type StatusType = typeof ACTIVE | typeof INACTIVE | typeof PUBLISHED | typeof UNPUBLISHED | typeof PENDING
export interface StatusSwitcherProps extends React.HTMLAttributes<HTMLDivElement> {
    status: StatusType
    disabled?: boolean
}

const Button = styled.div`
    user-select: none;
    cursor: pointer;
    line-height: 0;
`
const StatusButton = styled(Button)<StatusSwitcherProps>`
    opacity: ${(props) => (props.disabled ? 0.7 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
    color: ${(props) => {
        if (props.status === ACTIVE) return props.theme.statusSwitcherActiveColor
        if (props.status === INACTIVE) return props.theme.statusSwitcherInactiveColor
        if (props.status === PUBLISHED) return props.theme.statusSwitcherPublishedColor
        if (props.status === UNPUBLISHED) return props.theme.statusSwitcherUnpublishedColor
        return "grey"
    }};

    & > i {
        font-size: 16px;
    }
`
const SpinnerIconButton = styled(Button)`
    pointer-events: none;
    color: ${(props) => props.theme.statusSwitcherLoaderColor};

    & > i {
        font-size: 20px;
    }
`

export const StatusSwitcher = ({
    status,
    ...other
}: StatusSwitcherProps) => {
    if (status === PENDING) {
        return (
            <SpinnerIconButton {...other}>
                <SpinnerIcon />
            </SpinnerIconButton>
        )
    }
    return (
        <StatusButton
            status={status}
            {...other}
        >
            { status === ACTIVE && <RadioCheckedIcon /> }
            { status === INACTIVE && <RadioUncheckedIcon /> }
            { status === PUBLISHED && <EyeIcon /> }
            { status === UNPUBLISHED && <EyeBlockedIcon /> }
        </StatusButton>
    )
}
